import { sitePages } from '@/config/pages'

/* Where the nav's Team and Contact links go. Pages with their own team or contact section link to
   it; everywhere else they lead to the home page's sections. */

type SectionLinks = {
  team: string
  contact: string
  /** About lists the team itself, so its footer leaves the Team link out. */
  teamInFooter: boolean
}

const pageSections: Record<string, SectionLinks> = {
  [sitePages.home.path]: { team: '#team', contact: '#contact', teamInFooter: true },
  [sitePages.howItWorks.path]: { team: '/#team', contact: '#w-next', teamInFooter: true },
  [sitePages.about.path]: { team: '#a-team', contact: '#a-next', teamInFooter: false },
  [sitePages.faq.path]: { team: '/#team', contact: '#first-step', teamInFooter: true },
}

const elsewhere: SectionLinks = { team: '/#team', contact: '/#contact', teamInFooter: true }

/** "/about/" and "/about" are the same page. */
const pagePath = (pathname: string) => pathname.replace(/\/+$/, '') || '/'

export const sectionLinks = (pathname: string) => pageSections[pagePath(pathname)] ?? elsewhere

const pagesWithMotion = new Set([sitePages.home.path, sitePages.howItWorks.path])

/** Pages with animation, where the footer offers the pause control. */
export const hasMotion = (pathname: string) => pagesWithMotion.has(pagePath(pathname))
